module.exports = __webpack_public_path__ + "media/customizations/kalaiola/back-7772066b8c049d478ecd5ee5509ade1e.jpg";